import React from "react";
import "./Footer.css";
import facebookIcon from "../assets/facebook-logo.svg";
import googleIcon from "../assets/google-logo.svg";
// import yelpIcon from "../assets/yelp-logo.svg";

const Footer = () => (
    <footer className="footer">
        <h2 id="contact">Contact Us</h2>
        <p>
            <a href="tel:+19286076497" className="footer-link">
                <i className="fas fa-phone"></i> (928) 607-6497
            </a>
        </p>
        <p>
            <a href="mailto:cottonwoodwindowtinting1@yahoo.com" className="footer-link">
                <i className="fas fa-envelope"></i> cottonwoodwindowtinting1@yahoo.com
            </a>
        </p>
        <div className="social-media-icons">
            <a
                href="https://www.facebook.com/profile.php?id=100057505927578"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
            >
                <img src={facebookIcon} alt="Facebook" />
            </a>
            <a
                href="https://maps.app.goo.gl/ij2mMEPfKKyZPdHJA"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Google"
            >
                <img src={googleIcon} alt="Google" />
            </a>
        </div>
        <p className="footer-note">
            Designed and Built by <a href="https://verde-designs.com" target="_blank" rel="noopener noreferrer">Verde Designs.</a>
            <br />
            &copy; 2024 Cottonwood Tinting Home & Business. All rights
            reserved.
        </p>
    </footer>
);

export default Footer;
